import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const images = [
    {
      url: 'https://public.readdy.ai/ai/img_res/e8ecab1025c40fcfa4d2e22b60d3c0b6.jpg',
      title: 'PvP Arena'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=minecraft%20survival%20base%20beautiful%20building%20with%20farms%20and%20structures%20blue%20sky%20detailed%20construction%20player%20home%20creative%20architecture&width=800&height=600&seq=gallery-002&orientation=landscape',
      title: 'Survival Üssü'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=minecraft%20skyblock%20floating%20island%20in%20sky%20with%20builds%20and%20farms%20blue%20atmosphere%20creative%20island%20design%20unique%20structures&width=800&height=600&seq=gallery-003&orientation=landscape',
      title: 'Skyblock Adası'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=minecraft%20bedwars%20game%20scene%20with%20beds%20and%20bridges%20blue%20team%20competitive%20gameplay%20action%20packed%20mini%20game%20environment&width=800&height=600&seq=gallery-004&orientation=landscape',
      title: 'BedWars'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=minecraft%20medieval%20castle%20build%20with%20towers%20and%20walls%20blue%20banners%20detailed%20architecture%20epic%20fortress%20construction&width=800&height=600&seq=gallery-005&orientation=landscape',
      title: 'Klan Kalesi'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=minecraft%20spawn%20area%20with%20shops%20and%20portals%20blue%20theme%20detailed%20hub%20world%20player%20gathering%20place%20beautiful%20architecture&width=800&height=600&seq=gallery-006&orientation=landscape',
      title: 'Spawn Bölgesi'
    }
  ];

  return (
    <section id="gallery" className="py-20 px-4 bg-[#0f1420]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Galeri
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Sunucumuzdan en güzel anlar ve oyuncu yapıtları
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div 
              key={index}
              className="group relative overflow-hidden rounded-xl cursor-pointer"
              onClick={() => setSelectedImage(index)}
            >
              <div className="w-full h-64">
                <img 
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{image.title}</h3>
                  <div className="flex items-center text-[#3b82f6]">
                    <span className="text-sm">Görüntüle</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </div>
              <div className="absolute top-4 right-4 w-10 h-10 bg-[#3b82f6]/80 backdrop-blur-sm rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-zoom-in-line text-white text-xl"></i>
              </div>
            </div>
          ))}
        </div>

        {selectedImage !== null && (
          <div 
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button 
              className="absolute top-4 right-4 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center text-white hover:bg-white/20 transition-colors cursor-pointer"
              onClick={() => setSelectedImage(null)}
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            
            <div className="max-w-5xl w-full">
              <img 
                src={images[selectedImage].url}
                alt={images[selectedImage].title}
                className="w-full h-auto rounded-xl"
              />
              <h3 className="text-2xl font-bold text-white text-center mt-6">
                {images[selectedImage].title}
              </h3>
            </div>

            {selectedImage > 0 && (
              <button 
                className="absolute left-4 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center text-white hover:bg-white/20 transition-colors cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(selectedImage - 1);
                }}
              >
                <i className="ri-arrow-left-line text-2xl"></i>
              </button>
            )}

            {selectedImage < images.length - 1 && (
              <button 
                className="absolute right-4 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center text-white hover:bg-white/20 transition-colors cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedImage(selectedImage + 1);
                }}
              >
                <i className="ri-arrow-right-line text-2xl"></i>
              </button>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
